import { Elements, RecurlyProvider } from "@recurly/react-recurly";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, useNavigate } from "react-router-dom";
import MainLoader from "../../components/MainLoader";
import AuthLayout from "../../layouts/AuthLayout";
import BottomTabLayout from "../../layouts/BottomTabLayout";
import SelectionLayout from "../../layouts/SelectionLayout";
import AiBots from "../../pages/ai/AiBots";
import AiChat from "../../pages/ai/AiChat";
import AllBots from "../../pages/ai/AllBots";
import Privacy from "../../pages/auth/legal/Privacy";
import Terms from "../../pages/auth/legal/Terms";
import Login from "../../pages/auth/login/Login";
import Payment from "../../pages/auth/payment/Payment";
import AgeSelection from "../../pages/auth/signup/AgeSelection";
import AiPromotion from "../../pages/auth/signup/AiPromotion";
import AiTools from "../../pages/auth/signup/AiTools";
import FSituation from "../../pages/auth/signup/FSituation";
import GenderSelection from "../../pages/auth/signup/GenderSelection";
import GoalSelection from "../../pages/auth/signup/GoalSelection";
import IncomeLevel from "../../pages/auth/signup/IncomeLevel";
import Incomeslab from "../../pages/auth/signup/IncomeSlab";
import IncomeSrc from "../../pages/auth/signup/IncomeSrc";
import JobSelection from "../../pages/auth/signup/JobSelection";
import KnowledgeRating from "../../pages/auth/signup/KnowledgeRating";
import MailForm from "../../pages/auth/signup/MailForm";
import Otp from "../../pages/auth/signup/Otp";
import PersonalPlan from "../../pages/auth/signup/PersonalPlan";
import PlanLoading from "../../pages/auth/signup/PlanLoading";
import Platforms from "../../pages/auth/signup/Platforms";
import ProfileSummary from "../../pages/auth/signup/ProfileSummary";
import RemoteWork from "../../pages/auth/signup/RemoteWork";
import TimeSpending from "../../pages/auth/signup/TimeSpending";
import TravelWithWork from "../../pages/auth/signup/TravelWithWork";
import WeekPlan from "../../pages/auth/signup/WeekPlan";
import WishToAchieve from "../../pages/auth/signup/WishToAchieve";
import WorkLifeBalance from "../../pages/auth/signup/WorkLifeBalance";
import WorkSituation from "../../pages/auth/signup/WorkSituation";
import CourseVideo from "../../pages/courses/CourseVideo";
import Courses from "../../pages/courses/Courses";
import ManageSubscription from "../../pages/subscription/ManageSubscription";
import Netfy from "../../pages/Netfy";
import P1 from "../../pages/P1";
import Demo from "../../pages/Demo";

const RedirectToRoot = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/", { replace: true });
  }, []);
  return <></>;
};

const AuthRouter = () => {
  const state = useSelector((state) => {
    return state.authState;
  });

  return (
    <>
      {commonRoutes.map((route, index) => (
        <Route key={index} path={route.route} element={route.component} />
      ))}
      <Route
        path="/p1"
        element={
          <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_KEY}>
            <Elements>
              <P1 />
            </Elements>
          </RecurlyProvider>
        }
      />

      {state.loggedIn ? (
        <>
          <Route element={<BottomTabLayout />}>
            <Route element={<AuthLayout />}>
              {privateRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.route}
                  element={route.component}
                />
              ))}
            </Route>
          </Route>
          <Route path="/ai/chat" element={<AiChat />} />
        </>
      ) : (
        <>
          <Route element={<SelectionLayout />}>
            {publicRoutes.map((route, index) => (
              <Route key={index} path={route.route} element={route.component} />
            ))}
          </Route>
          <Route path="/:gender/planloading" element={<PlanLoading />} />
          <Route path="/:gender/profileSummary" element={<ProfileSummary />} />
          <Route
            path="/payment"
            element={
              <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_KEY}>
                <Elements>
                  <Payment />
                </Elements>
              </RecurlyProvider>
            }
          />
        </>
      )}
    </>
  );
};

const commonRoutes = [
  {
    route: "/terms",
    component: <Terms />,
  },
  {
    route: "/privacy",
    component: <Privacy />,
  },
  {
    route: "/otp",
    component: <Otp />,
  },
  {
    route: "/subscription",
    component: <ManageSubscription />,
  },
  {
    route: "/netfy",
    component: <Netfy />,
  },
  // {
  //   route: "/p2",
  //   component: <P1 />,
  // },
  // {
  //   route: "/p1",
  //   component: <P1 />,
  // },
  {
    route: "*",
    component: <MainLoader />,
  },
];

const publicRoutes = [
  {
    route: "/",
    component: <GenderSelection />,
  },
  {
    route: "/freelancer",
    component: <GenderSelection text="personalized_freelance_plan" />,
  },
  {
    route: "/ownboss",
    component: <GenderSelection text={"start_freelance_business"} />,
  },
  {
    route: "/successfulbusiness",
    component: <GenderSelection text="launch_successful_business" />,
  },
  {
    route: "/quiz",
    component: <RedirectToRoot />,
  },
  {
    route: "/start-quiz",
    component: <RedirectToRoot />,
  },
  {
    route: "/chat-mentor",
    component: <RedirectToRoot />,
  },
  {
    route: "/:gender/ageselection",
    component: <AgeSelection />,
  },
  {
    route: "/:gender/goal",
    component: <GoalSelection />,
  },
  {
    route: "/:gender/income",
    component: <IncomeSrc />,
  },
  {
    route: "/:gender/level",
    component: <IncomeLevel />,
  },
  {
    route: "/:gender/situation",
    component: <FSituation />,
  },
  {
    route: "/:gender/incomeslab",
    component: <Incomeslab />,
  },
  {
    route: "/:gender/remotework",
    component: <RemoteWork />,
  },
  {
    route: "/:gender/workbalance",
    component: <WorkLifeBalance />,
  },
  {
    route: "/:gender/worksituation",
    component: <WorkSituation />,
  },
  {
    route: "/:gender/travel",
    component: <TravelWithWork />,
  },
  {
    route: "/:gender/contentwritingrating",
    component: <KnowledgeRating ratingType={"content writing"} />,
  },
  {
    route: "/:gender/aiTools",
    component: <AiTools />,
  },
  {
    route: "/:gender/digitalmarketingrating",
    component: <KnowledgeRating ratingType={"digital marketing"} />,
  },
  {
    route: "/:gender/abilityrating",
    component: <KnowledgeRating ratingType={"business ability"} />,
  },
  {
    route: "/:gender/aipromotion",
    component: <AiPromotion />,
  },
  {
    route: "/:gender/jobs",
    component: <JobSelection />,
  },
  {
    route: "/:gender/readinessrating",
    component: <KnowledgeRating ratingType={"readiness"} />,
  },
  {
    route: "/:gender/platform",
    component: <Platforms />,
  },
  {
    route: "/:gender/wishes",
    component: <WishToAchieve />,
  },
  {
    route: "/:gender/timespending",
    component: <TimeSpending />,
  },
  {
    route: "/:gender/personalPlan",
    component: <PersonalPlan />,
  },
  {
    route: "/:gender/emailForm",
    component: <MailForm />,
  },
  {
    route: "/:gender/weekPlan",
    component: <WeekPlan />,
  },
  {
    route: "/login",
    component: <Login />,
  },
];

const privateRoutes = [
  {
    route: "/ai",
    component: <AiBots />,
  },
  {
    route: "/ai/allBots",
    component: <AllBots />,
  },
  {
    route: "/courses",
    component: <Courses />,
  },
  {
    route: "/courses/:id",
    component: <CourseVideo />,
  },
];

export default AuthRouter;
